import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ArrowUpDown, ChevronDown } from "lucide-react";
import { cn } from "@/components/utils/utils";
import { useI18n } from "@/hooks/useI18n";
import type { TranslationKey } from "@/types/i18n.types";

export type SortMode = 'newest' | 'oldest' | 'upcoming' | 'customer' | 'budget-high' | 'budget-low';

interface SortTravelRequestButtonProps {
  sortMode: SortMode;
  onSortModeChange: (mode: SortMode) => void;
  disabled?: boolean;
}

const SORT_OPTIONS: { mode: SortMode; labelKey: TranslationKey }[] = [
  { mode: 'newest', labelKey: 'dashboard.toolbar.sortNewest' },
  { mode: 'oldest', labelKey: 'dashboard.toolbar.sortOldest' },
  { mode: 'upcoming', labelKey: 'dashboard.toolbar.sortUpcoming' },
  { mode: 'customer', labelKey: 'dashboard.toolbar.sortCustomer' },
  { mode: 'budget-high', labelKey: 'dashboard.toolbar.sortBudgetHigh' },
  { mode: 'budget-low', labelKey: 'dashboard.toolbar.sortBudgetLow' },
];

/**
 * Scelta dell'ordinamento. L'ordinamento vero lo fa la RPC
 * get_dashboard_travel_requests_page: la lista e' paginata, qui non c'e' da ordinare.
 */
export const SortTravelRequestButton: React.FC<SortTravelRequestButtonProps> = ({
  sortMode,
  onSortModeChange,
  disabled = false,
}) => {
  const { t } = useI18n();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="flex items-center gap-1 sm:gap-2"
          disabled={disabled}
        >
          <ArrowUpDown className="h-4 w-4" />
          <span className="hidden sm:inline">{t('dashboard.toolbar.sort')}</span>
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SORT_OPTIONS.map(({ mode, labelKey }) => (
          <DropdownMenuItem
            key={mode}
            onClick={() => onSortModeChange(mode)}
            className={cn(sortMode === mode && "bg-accent")}
          >
            {t(labelKey)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
